<div class="pdq-item">
  <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start start">
    <h2>PDQ ITI-21</h2>
  </div>
  <div class="source">
    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
      <div fxLayout="column">Source </div>
      <div fxLayout="column">
        <input nz-input type="text" [(ngModel)]="ip" />
      </div>
      <div fxLayout="column">:</div>
      <div fxLayout="column" fxFlex="70px">
        <input nz-input type="number" [(ngModel)]="port" />
      </div>
    </div>
  </div>
  <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="center start" class="">
    <div fxLayout="column" fxFlex="90">
      <textarea rows="3" nz-input class="text-area-pdq" placeholder="PDQ ITI-21" [(ngModel)]="value"></textarea>
    </div>
    <div fxLayout="column" fxFlex="10">
      <button nz-button (click)="pdqiti21()">PDQ ITI-21</button>
    </div>
  </div>
  <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="center start" class="pdq-container">
    <div fxLayout="column" fxFlex="90">
      <textarea [rows]="resultRows" nz-input class="text-area-pdq" [value]="result" [disabled]="true"></textarea>
      @if (patientsData.length > 0) {
        <app-reusable-table
          [columns]="['Name', 'Gender', 'Birth Date', 'Identifiers', 'Address']"
          [rowFields]="['name', 'gender', 'birthDate', 'identifiers', 'address']" [data]="patientsData"
          [isLoading]="false" [isPreview]="true" [pagination]="false" />
      }
    </div>
    <div fxLayout="column" fxFlex="10">
    </div>
  </div>
</div>